import React, {Component} from 'react';
import MaterialIcon from '../../../../MaterialIcon';
import {LogicVersionItem} from "./LogicVersionItem";

class NavigationContainers extends Component {
    constructor(props){
        super(props);
        this.state = {
            activeTab: 0,
            collapseItems: [
                {
                    title: 'First Blocks',
                    type: 'first-blocks',
                    color: '#0E9F9E',
                    active: true,
                    items: [
                        /*{
                            title: 'All Items',
                            type: 'all_items'
                        },*/
                        {
                            title: 'Search First Block',
                            type: 'search_first_block'
                        },
                        {
                            title: 'Editorial',
                            type: 'editorial'
                        },
                        /*{
                            title: 'Event Provider',
                            type: 'event_provider'
                        },*/
                        {
                            title: 'No Items',
                            type: 'no_items'
                        },
                        {
                            title: 'Input Items',
                            type: 'input_items'
                        },
                        {
                            title: 'Context First Block',
                            type: 'context_to_first'
                        },
                        {
                            title: 'Scoring',
                            type: 'scoring'
                        }
                    ]
                },
                {
                    title: 'Scoring',
                    type: 'algorithms',
                    color: '#C0165F',
                    active: true,
                    items: [
                        {
                            title: 'Scoring',
                            type: 'scoring'
                        }
                        // {
                        //     title: 'Aggregator First Block',
                        //     type: 'aggregator_first_block'
                        // }
                    ]
                },
                {
                    title: 'Filters',
                    type: 'filters',
                    color: '#C4D600',
                    active: true,
                    items: [
                        {
                            title: 'Item Filter',
                            type: 'item_filter'
                        },
                        /*{
                            title: 'SorterPagerCacher',
                            type: 'sorter'
                        },*/
                        {
                            title: 'Sorter',
                            type: 'sorter_only'
                        },
                        /*{
                            title: 'Pager',
                            type: 'pager'
                        },
                        {
                            title: 'Pager',
                            type: 'pager'
                        },
                        {
                            title: 'P Value Range',
                            type: 'p_value_range'
                        },
                        {
                            title: 'Realtime Equals',
                            type: 'realtime_equals'
                        },
                        {
                            title: 'First Valid Combination',
                            type: 'first_valid_combination'
                        },
                        {
                            title: 'Faceting Filter',
                            type: 'faceting_filter'
                        }*/
                    ]
                },
                {
                    title: 'Mutators',
                    type: 'mutators',
                    color: '#CD635B',
                    active: true,
                    items: [
                        /* {
                             title: 'Prediction Normalizer',
                             type: 'prediction_normalizer'
                         },*/
                        {
                            title: 'Group by Property',
                            type: 'group_by_property'
                        },
                        /*{
                            title: 'Dynamic Property',
                            type: 'dynamic_property'
                        },*/
                        {
                            title: 'Cache',
                            type: 'cache'
                        },
                        {
                            title: 'Field Modifier',
                            type: 'field_modifier'
                        },
                        /*{
                            title: 'Context Property Modifier',
                            type: 'context_property_modifier'
                        },*/
                        /*{
                            title: 'Context Updater',
                            type: 'context_updater'
                        },*/
                        {
                            title: 'Context Modifier',
                            type: 'context_modifier'
                        },
                        {
                            title: 'Logic to Context',
                            type: 'logic_to_context'
                        },
                        /*
                        {
                            title: 'Push',
                            type: 'push'
                        },
                        */

                        /*
                        {
                            title: 'Items to Context',
                            type: 'items_to_context'
                        }*/
                    ]
                },
                {
                    title: 'Switches',
                    type: 'switches',
                    color: '#FFE830',
                    active: true,
                    items: [
                        {
                            title: 'Switch',
                            type: 'switch'
                        }
                        /*,
                        {
                            title: 'User Segment',
                            type: 'user_segment'
                        }*/,
                        {
                            title: 'A/B Test',
                            type: 'a_b_test'
                        }
                    ]
                },
                {
                    title: 'Combinators',
                    type: 'combinators',
                    color: '#43B02A',
                    active: true,
                    items: [
                        {
                            title: 'Blender',
                            type: 'blender'
                        }
                        /*,{
                             title: 'Combinator',
                             type: 'combinator'
                        }*/
                    ]
                },
                {
                    title: 'Components',
                    type: 'components',
                    color: '#deb120',
                    active: true,
                    items: [
                        {
                            title: 'Component',
                            type: 'component'
                        }
                    ]
                },
                {
                    title: 'Custom blocks',
                    type: 'customs',
                    color: '#8e7cc3',
                    active: true,
                    items: [
                        {
                            title: 'Custom',
                            type: 'custom'
                        }
                    ]
                },
                /*,
                {
                    title: 'Advanced',
                    type: 'advanced',
                    color: '#808080',
                    active: true,
                    items: [
                        {
                            title: 'Custom',
                            type: 'custom'
                        }
                    ]
                }*/
            ]
        }
        this.selectedTab = this.selectedTab.bind(this);
        this.selectedCollapse = this.selectedCollapse.bind(this);
    }
    selectedTab(value){
        this.setState({
            activeTab: value
        });
    }
    selectedCollapse(index){
        const collapseItem = this.state.collapseItems,
            collapseItemActive = !this.state.collapseItems[index].active,
            collapseItemConvert = collapseItem[index].active = collapseItemActive;
        this.setState({
            collapseItem: collapseItemConvert
        });
    }

    render(){
        const collapseRender = () => {
            return this.state.collapseItems.map((v,i) => {
                const sectionType = v.type;
                let collapseItem = v.items.map((value,key) => (
                    <div
                        key={`item-${key}`}
                        className="drag-item"
                        style={{backgroundColor : v.color}}
                        data-type={value.type}
                        draggable="true" onDragStart={(event) => this.props.dragProps(event, value.title, value.type, sectionType)}
                        onClick={() => {this.props.clickNode(value.title, value.type, sectionType)}}
                    >
                        {value.title}
                    </div>
                ));
                const createClassName = v.active ? 'collapse-item active' : 'collapse-item';
                return (
                    <div key={i} className={createClassName} data-type={v.type}>
                        <header className="collapse-top" onClick={() => this.selectedCollapse(i)}>
                            <span>{v.title}</span>
                            <MaterialIcon icon="keyboard_arrow_up" />
                        </header>
                        <div className="collapse-content">
                            <div className="drag-items">
                                {collapseItem}
                            </div>
                        </div>
                    </div>
                )
            });
        }

      const renderLogicVersions = (logicVersions) => {
        return (
            <div className="logic-versions-list">
              {logicVersions.map((version, i) => {
                  return (<LogicVersionItem key={`version-item-${i}`}
                                            versionItem={version}
                                            logicId={this.props.logicId}
                  />)
              })}
            </div>
        )
      }

        return (
            <div className={this.props.tabData.show ? 'navigation-containers active' : 'navigation-containers'}>
                <div className={this.props.tabData.newNodes ? 'item-container active' : 'item-container'}>
                    {/* <div className="search-area">
                        <input name="search-item" placeholder="Search" />
                        <MaterialIcon icon="search" />
                    </div> */}
                    {/* <div className="tab-area">
                        <span onClick={() => this.selectedTab(0)} className={this.state.activeTab === 0 ? 'active item': 'item'}>New</span>
                        <span onClick={() => this.selectedTab(1)} className={this.state.activeTab === 1 ? 'active item': 'item'}>Components</span>
                    </div> */}
                    <div className="tab-containers">
                        <div className={this.state.activeTab === 0 ? 'active tab-item': 'tab-item'}>
                            {collapseRender()}
                        </div>
                        <div className={this.state.activeTab === 1 ? 'active tab-item': 'tab-item'}>
                            Components
                        </div>
                    </div>
                </div>
                <div className={this.props.tabData.versionHistory ? 'item-container active' : 'item-container'}>
                    <div className="tab-containers">
                        <div className={this.state.activeTab === 0 ? 'active tab-item': 'tab-item'}>
                            {renderLogicVersions(this.props.logicVersions)}
                        </div>
                        <div className={this.state.activeTab === 1 ? 'active tab-item': 'tab-item'}>
                            Components
                        </div>
                    </div>
                </div>
{/*             <div className={this.props.tabData.finder ? 'item-container active' : 'item-container'}>
                    Finder Container
                </div>
                <div className={this.props.tabData.version ? 'item-container active' : 'item-container'}>
                    Version Container
                </div>
                <div className={this.props.tabData.usages ? 'item-container active' : 'item-container'}>
                    Usages Container
                </div>
                <div className={this.props.tabData.context ? 'item-container active' : 'item-container'}>
                    Context Container
                </div>
                <div className={this.props.tabData.variables ? 'item-container active' : 'item-container'}>
                    Variables Container
                </div>*/}
            </div>
        )
    }
}

export default NavigationContainers;
